module.exports = __webpack_public_path__ + "img/france-transport-accidents-male.9e7bb7fa.png";